import { render, staticRenderFns } from "./jiangcheng.vue?vue&type=template&id=6213a188&scoped=true&"
import script from "./jiangcheng.vue?vue&type=script&lang=js&"
export * from "./jiangcheng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213a188",
  null
  
)

export default component.exports